<ng-container>
  <div class="trust_container" *ngIf="inIframe">
    <img
      class="w-100"
      alt="trust-seal"
      [attr.data-e2e]="'trust-seal'"
      [src]="
        'brand/' + this.staticBrand + '/trust-seals/gray_' + lang + '.svg'
          | orderformAsset
      "
    />
  </div>

  <div
    [attr.data-e2e]="'form:footer'"
    class="footer-container d-flex flex-column"
  >
    <div>
      <a
        *ngFor="let item of footerMenuItems$ | async; trackBy: trackByLabel"
        class="footer-item px-3"
        [attr.id]="item.id"
        (click)="openModal(item)"
      >
        {{ item.label }}
      </a>
    </div>

    <div class="mt-3" i18n="@@form_footer.copyright_with_dyn_brand">
      &copy; {{ year }} {{ reseller$ | async }}, alle Rechte vorbehalten
    </div>

    <div class="affiliate">
      [
      <ng-container *ngIf="affiliate$ | async as affiliate; else noAffiliate">{{
        affiliate.name
      }}</ng-container>
      <ng-template #noAffiliate>
        <ng-container i18n="@@form_footer.is_no_affiliate">none </ng-container>
      </ng-template>
      ]
    </div>
  </div>
</ng-container>
